import React from "react"
import { Button, Icon } from "antd";
import { HeaderApp } from "./Header"
import { FooterApp } from "./Footer"
import "./animate.min.css"
import "./index.css"



const LayoutGlobal = ({ children }) => {

  return (
    <>
      <HeaderApp />
      {children}
      <FooterApp />
    </>
  )
}
export default LayoutGlobal;
